export const darkTheme = {
    bg:"#05070a",
    bgLight: "#00008B",
    primary:" #CD7F32",
    text_primary:"#FFFFFF",
    text_secondary:"#FFFFFF",
    card:"#00070d",
    card_light: "#000000",
    button:"#854CE6",
    white:"#FFFFFF",
    black:"#000000",
}

export const lightTheme = {
    bg:"#D7BFDC",
    bgLight: "#00008B",
    primary:"#00308F",
    text_primary:"#00308F",
    text_secondary:"#00008B",
    card:" #00308F",
    button:" #00308F",
}